export interface BlogPost {
  id: number;
  title: string;
  date: string;
  author: string;
  category: string;
  snippet: string;
  content: string; // HTML content for the detail page
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: "All About Jigsaw by Black+Decker & Dewalt",
    date: "March 25, 2021",
    author: "akshit chotani",
    category: "Power Tools",
    snippet: "A jigsaw is the best-selling and valued power tool that is used in a vast range of cutting applications. A good power tool can save half of the effort when…",
    content: `
      <p>A jigsaw is the best-selling and valued power tool that is used in a vast range of cutting applications. A good power tool can save half of the effort when working on a project, and the jigsaw is one of the most versatile of all.</p>
      <h2>Why choose Black+Decker & Dewalt?</h2>
      <p>Both brands are industry leaders in creating power tools that not only get the job done but last a lifetime. Whether you are cutting wood, plastic, or metal, their jigsaws provide the precision and power necessary for professional results.</p>
      <p>Here are some tips for using a jigsaw effectively:</p>
      <ul>
        <li>Always use the correct blade for the material.</li>
        <li>Secure your workpiece firmly before cutting.</li>
        <li>Let the saw do the work; don't force it through the material.</li>
      </ul>
      <p>Invest in quality, and your projects will reflect that investment.</p>
    `
  },
  {
    id: 2,
    title: "Apple Cider Vinegar, Health with Taste by HealthKart",
    date: "March 24, 2021",
    author: "akshit chotani",
    category: "General",
    snippet: "Apple Cider Vinegar is made mostly of apple juice, by adding yeast to it, results in turning sugar in the juice into alcohol. This process is known as fermentation as…",
    content: `
      <p>Apple Cider Vinegar is made mostly of apple juice, by adding yeast to it, results in turning sugar in the juice into alcohol. This process is known as fermentation.</p>
      <h2>The Benefits of Apple Cider Vinegar</h2>
      <p>ACV is known for its numerous health benefits, including:</p>
      <ul>
        <li>Aiding in weight loss and metabolism boosting.</li>
        <li>Helping to lower blood sugar levels.</li>
        <li>Improving digestion and gut health.</li>
      </ul>
      <p>HealthKart provides high-quality, unfiltered ACV with "The Mother", ensuring you get all the beneficial enzymes and bacteria.</p>
    `
  },
  {
    id: 3,
    title: "Best Heat Guns in the Market by Stanley & Black+Decker",
    date: "March 24, 2021",
    author: "akshit chotani",
    category: "General",
    snippet: "A heat gun is a gadget that is used to discharge a wave of hot air. Heat gun has the form of an elongated body pointing at what is being…",
    content: `
      <p>A heat gun is a gadget that is used to discharge a wave of hot air. Heat gun has the form of an elongated body pointing at what is being heated.</p>
      <h2>Common Uses for Heat Guns</h2>
      <p>These versatile tools can be used for:</p>
      <ul>
        <li>Stripping old paint or wallpaper.</li>
        <li>Thawing frozen pipes.</li>
        <li>Shrink wrapping packaging.</li>
      </ul>
      <p>Stanley and Black+Decker offer robust models with variable temperature controls for any application.</p>
    `
  },
  {
    id: 4,
    title: "Must have appliances to keep you cool this summer",
    date: "March 24, 2021",
    author: "nistha singh",
    category: "Appliances",
    snippet: "Summer is here! You definitely cannot change the temperature outside. But at the office or home, there are certain appliances that you must have, to keep you cool this summer…",
    content: `
      <p>Summer is here! You definitely cannot change the temperature outside. But at the office or home, there are certain appliances that you must have, to keep you cool this summer.</p>
      <h2>Top Appliances for Summer</h2>
      <p>Consider upgrading or investing in:</p>
      <ul>
        <li>Energy-efficient inverter ACs.</li>
        <li>High-speed ceiling and pedestal fans.</li>
        <li>Air coolers for dry climates.</li>
      </ul>
      <p>Stay cool and productive by choosing the right appliance for your space size and climate.</p>
    `
  },
  {
    id: 5,
    title: "Omron Nebulizers: Solution to your Respiratory Problems",
    date: "March 22, 2021",
    author: "akshit chotani",
    category: "Medical Supplies",
    snippet: "Every breath is essential for a healthy life. There are people who face various respiratory problems like asthma, Chronic obstructive pulmonary disease (COPD), etc, and are not able to live…",
    content: `
      <p>Every breath is essential for a healthy life. There are people who face various respiratory problems like asthma, Chronic obstructive pulmonary disease (COPD), etc, and are not able to live comfortably without intervention.</p>
      <h2>Why Omron?</h2>
      <p>Omron nebulizers are globally recognized for their reliability, efficiency, and quiet operation. They effectively convert liquid medication into a fine mist, ensuring it reaches deep into the lungs.</p>
      <p>Whether for pediatric or adult use, Omron has a model suited to your specific needs.</p>
    `
  },
  {
    id: 6,
    title: "Best Cordless Tools in the Market by Black+Decker",
    date: "March 19, 2021",
    author: "akshit chotani",
    category: "Power Tools",
    snippet: "Cordless tools have proven to be handy among their users as these run on batteries which increases productivity while working. Such tools are very feasible to use and make your…",
    content: `
      <p>Cordless tools have proven to be handy among their users as these run on batteries which increases productivity while working. Such tools are very feasible to use and make your workspace safer by eliminating tripping hazards.</p>
      <h2>The Black+Decker Cordless Ecosystem</h2>
      <p>With interchangeable batteries across multiple tools, building a cordless toolkit has never been easier or more cost-effective. From drills to string trimmers, experience the freedom of cordless power.</p>
    `
  },
  {
    id: 7,
    title: "All About Omron HBF-375 Body Composition Monitor",
    date: "March 19, 2021",
    author: "akshit chotani",
    category: "Medical Supplies",
    snippet: "A body composition monitor is a must-have device for every home to measure aspects of your body composition like body weight, body mass index(BMI), skeletal muscle, body fat, visceral fat,…",
    content: `
      <p>A body composition monitor is a must-have device for every home to measure aspects of your body composition like body weight, body mass index(BMI), skeletal muscle, body fat, visceral fat, and resting metabolism.</p>
      <h2>Comprehensive Health Tracking</h2>
      <p>The Omron HBF-375 offers full-body sensing technology for a more accurate and comprehensive analysis compared to traditional foot-to-foot monitors. Keep your fitness goals on track with precise data.</p>
    `
  },
  {
    id: 8,
    title: "Boost up your performance with TrueBasics multivitamins!",
    date: "March 19, 2021",
    author: "akshit chotani",
    category: "Health",
    snippet: "Multivitamins are the most common and safest supplements worldwide. Some may think that multivitamins can improve your health, balance up poor eating habits, and also may cut down your risk…",
    content: `
      <p>Multivitamins are the most common and safest supplements worldwide. Some may think that multivitamins can improve your health, balance up poor eating habits, and also may cut down your risk of chronic diseases.</p>
      <h2>Formulated for Performance</h2>
      <p>TrueBasics offers clinically researched ingredients and specialized blends for men and women, focusing on energy, immunity, and joint health. Fill the nutritional gaps in your diet safely and effectively.</p>
    `
  },
  {
    id: 9,
    title: "Workwear Boiler Suit – A Full-proof protection for every industrial worker",
    date: "March 18, 2021",
    author: "Fizza Zaidi",
    category: "Safety",
    snippet: "The term ‘boiler suit’ is found to be first recorded in The Sunday Express in 1928 and the garment originated in the late 19th century. The word comes from the…",
    content: `
      <p>The term ‘boiler suit’ is found to be first recorded in The Sunday Express in 1928 and the garment originated in the late 19th century. The word comes from the men who maintained coal-fired boilers.</p>
      <h2>Modern Industrial Safety</h2>
      <p>Today's boiler suits are engineered with flame-retardant materials, high-visibility strips, and reinforced stitching to protect workers in the harshest environments. Comfort and safety must go hand-in-hand to ensure compliance and productivity on the shop floor.</p>
    `
  }
];
